import GLightbox from "glightbox";

const lightbox = GLightbox({
    selector: '[data-gallery]',
    touchNavigation: true,
    loop: true,
});

const menuButton = document.querySelector('.menu-button');

function setMenuOpen(open) {
    document.documentElement.classList.toggle('menu--active', open);
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
}

menuButton.addEventListener('click', function() {
    setMenuOpen(!document.documentElement.classList.contains('menu--active'));
});

document.querySelector('.menu-overlay').addEventListener('click', function(e) {
    e.preventDefault();
    setMenuOpen(false);
});

document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.documentElement.classList.contains('menu--active')) {
        setMenuOpen(false);
        menuButton.focus();
    }
});

const anchorlinks = [...document.querySelectorAll('[data-scroll]')];

anchorlinks.forEach(function(obj, index) {
    obj.addEventListener('click', function(e) {
       // Links may carry a page path before the anchor; only scroll if the target is on this page
       var anchor = obj.getAttribute('data-scroll').split("#")[1];
       var target = anchor && document.getElementById(anchor);
       if (!target) {
           return;
       }
       e.preventDefault();
       target.scrollIntoView({ behavior: 'smooth' })
       // var target_pos = el.getBoundingClientRect().top + document.body.scrollTop;

    });
});
